/* eslint-disable no-unused-vars */
import React, { useEffect, useRef } from "react";

const TrustpilotComponent = () => {
    const ref = useRef(null);

    useEffect(() => {
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(ref.current, true);
        }
    }, []);

    return (
        <div
            ref={ref}
            className="trustpilot-widget"
            data-locale="en-GB"
            data-template-id="5406e65db0d04a09e042d5fc"
            data-businessunit-id="594eb6c60000ff0005a54350"
            data-style-height="28px"
            data-style-width="100%"
            data-token="fb94b00a-c19b-4eb1-b027-095c25f06fb3"
        ></div>
    );
};

export default TrustpilotComponent;
